import Swal from "sweetalert2";

export const customSwall = Swal.mixin({
    customClass: {
        confirmButton: 'btn btn-azul',
        cancelButton: 'btn btn-rojo'
    },
    buttonsStyling: false,
});